import app from '../../forum/app';
import PaginatedListState from '../../common/states/PaginatedListState';
import EventEmitter from '../../common/utils/EventEmitter';
const globalEventEmitter = new EventEmitter();
export default class PostListState extends PaginatedListState {
  extraPosts = [];
  constructor(params, page = 1, pageSize = null) {
    super(params, page, pageSize);
    this.eventEmitter = globalEventEmitter;
  }
  get type() {
    return 'posts';
  }
  requestParams() {
    const params = {
      include: ['user', 'discussion'],
      filter: {
        type: 'comment',
        ...(this.params.filter || {})
      },
      sort: this.sortMap()[this.params.sort ?? ''] || '-createdAt'
    };
    if (this.params.q) {
      params.filter.q = this.params.q;
    }
    return params;
  }
  loadPage(page = 1) {
    const preloadedPosts = app.preloadedApiDocument();
    if (preloadedPosts) {
      this.initialLoading = false;
      this.pageSize = preloadedPosts.payload.meta?.perPage || PostListState.DEFAULT_PAGE_SIZE;
      return Promise.resolve(preloadedPosts);
    }
    return super.loadPage(page);
  }
  clear() {
    super.clear();
    this.extraPosts = [];
  }

  /**
   * Get a map of sort keys (which appear in the URL, and are used for
   * translation) to the API sort value that they represent.
   */
  sortMap() {
    const map = {};
    if (this.params.q) {
      map.relevance = '';
    }
    map.newest = '-createdAt';
    map.oldest = 'createdAt';
    return map;
  }
  getAllItems() {
    return this.extraPosts.concat(super.getAllItems());
  }
  getPages() {
    const pages = super.getPages();
    if (this.extraPosts.length) {
      return [{
        number: -1,
        items: this.extraPosts
      }, ...pages];
    }
    return pages;
  }
}
flarum.reg.add('core', 'forum/states/PostListState', PostListState);